import React from "react";
import { Dictionary } from "lodash";
import { Person } from "@/features/people/graphql/generated";
import { Team } from "@/features/teams/graphql/generated";
import { DimensionWithScores } from "@/features/people/hooks/useDimensionsWithScores";
import { PDFDocument, PdfContainer } from "../../generator";
import { HighlightsAndPersonality } from "./pages/Highlights";
import { Values } from "./pages/Values";
import { Competencies } from "./pages/Competencies";
import { TeamSummary } from "./pages/TeamSummary";

interface TeamProfilePdfProps {
  team: Team;
  members: Person[];
  dimensions: Dictionary<DimensionWithScores[]>;
  summary?: string;
  logoUrl?: string;
}

function TeamProfilePdf(props: TeamProfilePdfProps) {
  const { dimensions, team, members, summary } = props;

  // Combine all pages
  const pages = [
    <PdfContainer className="relative" key="team-profile-pdf">
      <TeamSummary team={team} members={members} summary={summary} />
      <HighlightsAndPersonality dimensions={dimensions} context="team" />
      <Values dimensions={dimensions} context="team" />
      <Competencies dimensions={dimensions} context="team" />
    </PdfContainer>,
  ];

  return <PDFDocument pages={pages} />;
}

export default TeamProfilePdf;
